const { animation } = window.o_util ?? {};
const { easings, fadeIn, fadeOut, scrollTo, requestAnimFrame, transition, transitions } = animation ?? {};
export {
  animation,
  easings,
  fadeIn,
  fadeOut,
  requestAnimFrame,
  scrollTo,
  transition,
  transitions
};
/*                                  */
